import React from 'react';
import { Form, Button } from 'reactstrap';

const Donate = () => {
  if (document.referrer.match(/sportscarglobal/)) {
    return null;
  }
  return (
    <Form
      action="https://www.paypal.com/cgi-bin/webscr"
      className='d-flex justify-content-center h-100 align-items-center'
      inline
      method="post"
      target="_top"
    >
      <input
        name="cmd"
        type="hidden"
        value="_s-xclick"
      />
      <input
        name="encrypted"
        type="hidden"
        value="-----BEGIN PKCS7-----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-----END PKCS7-----"
      />
      <Button
        color='link'
        name="submit"
        type="image"
      >
        <img
          alt="PayPal – The safer, easier way to pay online!"
          src="https://www.paypalobjects.com/en_GB/i/btn/btn_donate_SM.gif"
        />
      </Button>
      <img
        alt=""
        height="1"
        src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif"
        width="1"
      />
    </Form>
  );
};

export default Donate;
